import React from 'react';

import { FormMeta } from 'common/components/Form/propTypes';
import classNames from 'classnames';

class Radio extends React.Component {
  static propTypes = {
    meta: FormMeta.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.input.checked,
    };
  }

  render() {
    const { label, meta, className, disabled, name, id, ...props } = this.props;
    const { ...input } = props.input;
    const { touched, error, warning } = meta;
    const inputId = `radio-checkbox-${id}`;

    return (
      <div className={classNames(className, 'Field--radio')}>
        <input
          type="radio"
          id={inputId}
          name={name}
          disabled={disabled}
          checked={this.state.checked}
          {...input}
        />

        <label className="Field__label Field__label--radio" htmlFor={inputId}>
          <span className="Field__input--radio-button" />

          <div className="Field__label--content">{this.props.children}</div>
        </label>
        {touched &&
          ((error && <div className="Field__error">{error}</div>) ||
            (warning && <div className="Field__warning">{warning}</div>))}
      </div>
    );
  }
}

export default Radio;
